import token from '@/user/services/token';
export default function Auth(query) {
    if (token.accessToken) {
        query.addHeader('Authorization', `Bearer ${token.accessToken}`);
    }
    return query;
}
